import React, { useState, useEffect, useContext } from "react";
import { nextDocument } from "react-doc-viewer/build/state/actions";
import {Link, NavLink, useHistory} from 'react-router-dom';
import { Button } from 'reactstrap';
import EventContext from "../../contexts/event";
import SocketClient from '../../helpers/connection';
import {gql, useMutation} from "@apollo/client";
import {INSERT_QUIZ_ACTION} from "../../gql/quiz-gql";
import axios from "axios";
import {useIntl} from "react-intl";
import ButtonTooltip from "../button-tooltip";


//control panel for handeling the quiz
const FinalQuizControls: React.FC<{
  usersLength: number;
  presentationId?: string;
  answersLength: number;
  setStartTimer?: (arg0: boolean) => void;
  setResultPage?: (arg0: boolean) => void;
  mimicFormButtonClick?: () => void;
  nextQuestion?: () => void;
  answerId: string;
  noNext?: boolean;
  nextDisabled?: boolean;
  podium?: boolean;
  onBack?: boolean;
  questionIndex?: number;
}> = ({ usersLength, answersLength, setResultPage, setStartTimer, presentationId, answerId, mimicFormButtonClick, nextQuestion, noNext = false, nextDisabled = false, onBack = false, podium = true,questionIndex=0 }) => {

  const eventContext = useContext(EventContext);
    const history = useHistory();
    const intl = useIntl();





    // update changes in database and push socket message to clients
    function updateAction(jsonData:any) {
        console.log("updateAction >>> ",jsonData)
        console.log("updateAction >>> ",`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`)

        const headers = {
            'Content-Type': 'application/json',
        }

        axios.post(`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`, jsonData, {
            headers: headers
        })
            .then((response) => {

                console.log("response", response)
            })
            .catch((error) => {
                console.log("error", error)
            })
    }


  return (
    <div className="quiz-controls">
      <div className="connected-users-answers">

          <div className="common"><span>{usersLength}</span> {intl.formatMessage({ id: "quiz.connected" })}</div>


      </div>
      <div className="controls">
        {
          onBack && <ButtonTooltip id="final-podium-back" messageId="quiz.tooltip.back">
            <Button   onClick={()=>{
               history.goBack();
                updateAction( {
                        presentationId: presentationId,
                        action: "back",
                        question_index:questionIndex
                    }
                );
          }}  className="btn btn-next">{intl.formatMessage({ id: "button.common.back" })} </Button>
          </ButtonTooltip>
        }
        {
          setStartTimer && <ButtonTooltip id="final-quiz-stop-timer" messageId="quiz.tooltip.stop_timer">
            <Button onClick={() => {
            //socket.emit("action","timer_stop");
                updateAction( {
                    presentationId: presentationId,
                        action: "timer_stop",
                        question_index:questionIndex
                    }
                );
                //SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:timer_stop"}`);
             setStartTimer(false);
            }
            } className="stop-timer"><img src="/icons/stop-timer-ico.svg" alt="" /></Button>
          </ButtonTooltip>
        }
        {
          setStartTimer && <ButtonTooltip id="final-quiz-start-timer" messageId="quiz.tooltip.start_timer">
            <Button onClick={() =>{

                updateAction( {
                    presentationId: presentationId,
                    action: "timer_start",
                    question_index:questionIndex
                    }
                );

             setStartTimer(true);
            }} className="start-timer"><img src="/icons/start-timer-ico.svg" alt="" /></Button>
          </ButtonTooltip>
        }
        {
          mimicFormButtonClick && <Button className="stop-timer" onClick={() => mimicFormButtonClick()} >Submit</Button>
        }
        {
          podium && <ButtonTooltip id="final-quiz-podium" messageId="quiz.tooltip.podium">
            <Button className="btn"   onClick={()=>{

                updateAction( {
                    presentationId: presentationId,
                        action: "show_podium",
                        question_index:questionIndex
                    }
                );
                console.log("PAGE INDEX",questionIndex);
                SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:show_podium"}`);
                history.push(
                    `/${eventContext.slug}/${presentationId}/podium/${answerId}`,{'index':questionIndex+1}
                )

           // socket.emit("action","show_podium");
          }}><img src="/icons/podium-ico.svg" alt="" />Podium</Button>
          </ButtonTooltip>
        }
        {
          podium && <ButtonTooltip id="final-quiz-results" messageId="quiz.tooltip.results">
            <Button activeClassName="selected" className="btn" onClick={() => {
            if (setResultPage) {
                updateAction( {
                    presentationId: presentationId,
                    action: "show_result",
                    question_index:questionIndex
                    }
                );
                //SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:show_result"}`);
             // socket.emit("action","show_result");
              // show result action
              setResultPage(true)

            }
          }}><img src="/icons/results-ico.svg" alt="" />{intl.formatMessage({ id: "quiz.results.msg" })}</Button>
          </ButtonTooltip>
        }
        {
          !noNext && <ButtonTooltip id="final-quiz-next" messageId="quiz.tooltip.next">
            <Button disabled={nextDisabled} onClick={() => {

            if (setResultPage) {
              // hide result action
              setResultPage(false)
            }
            if (nextQuestion) {

                updateAction( {
                    presentationId: presentationId,
                    action: "next_question",
                    question_index:questionIndex+1
                });
                //SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:next_question"}`);
              nextQuestion?.();
            }
          }} className={`btn ${nextDisabled ? 'noHover' : ''}  btn-next`}>{intl.formatMessage({ id: "quiz.next" })} <img src="/icons/quiz-next-ico.svg" alt="" /></Button>
          </ButtonTooltip>
        }

      </div>
    </div>
  )
}

export default FinalQuizControls;


